import {Component, Inject, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DynamicFormService} from "../../../../shared/components/dynamic-forms-components/dynamic-form.service";
import {FormGroup, Validators} from "@angular/forms";
import {FieldConfig, FieldType} from "../../../../shared/components/dynamic-forms-components/field.interface";
import {StoreItemActions} from "../../../../store/entities/store-item/store-item.actions";
import {StoreItemEntity} from "../../../../store/entities/store-item/store-item.model";
import {Warehouse} from "../../../../store/entities/warehouse-management/warehouse/warehouse.model";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../store";
import {
  REGISTER_WAREHOUSE_MUTATION,
  UPDATE_WAREHOUSE_MUTATION
} from "../../../../store/entities/warehouse-management/warehouse/warehouse.graphql";
import {ALL_REGIONS} from "../../../../store/entities/settings/administrative-area/region/region.graphql";
import {
  ALL_DISTRICTS_BY_REGION
} from "../../../../store/entities/settings/administrative-area/district/district.graphql";
import {ALL_WARDS_BY_DISTRICT} from "../../../../store/entities/settings/administrative-area/ward/ward.graphql";
import {
  GET_ALL_GEOGRAPHICAL_ZONES_QUERY
} from "../../../../store/entities/settings/geographical-zone/geographical-zone.graphql";
import { DistrictActions } from '../../../../store/entities/settings/administrative-area/district/district.actions';
import { WardActions } from '../../../../store/entities/settings/administrative-area/ward/ward.actions';
import { StreetActions } from '../../../../store/entities/settings/administrative-area/street/street.actions';
import { selectAllDistricts } from '../../../../store/entities/settings/administrative-area/district/district.selectors';
import { map } from 'rxjs';
import { selectAllWards } from '../../../../store/entities/settings/administrative-area/ward/ward.selectors';


@Component({
  selector: 'app-warehouse-add',
  templateUrl: './warehouse-add.component.html',
  styleUrl: './warehouse-add.component.scss'
})
export class WarehouseAddComponent implements OnInit {
  private dialogRef: MatDialogRef<WarehouseAddComponent> = inject(MatDialogRef<WarehouseAddComponent>)
  private dynamicFormService: DynamicFormService = inject(DynamicFormService);

  title: string;
  loading:boolean= false

  form: FormGroup
  fields: FieldConfig[] = this.formFields()
  warehouse: Warehouse

  constructor(
      private store: Store<AppState>,
      @Inject(MAT_DIALOG_DATA) data,
  ) {
    this.warehouse = data?.warehouse
  }

  ngOnInit() {
    this.title = "Add Warehouse";
    if(this.warehouse){
      this.store.dispatch(DistrictActions.getAllDistrictByRegion({regionUniqueId: this.warehouse?.region?.uniqueId}));

      this.store.dispatch(WardActions.getAllWardsByDistrict({districtUniqueId: this.warehouse?.distric?.uniqueId}));
      
    }
    this.form = this.dynamicFormService.createControl(this.fields,
        {
          ...this.warehouse,
          uniqueId:this.warehouse?.uniqueId,
          region:this.warehouse?.region?.uniqueId,
          distric:this.warehouse?.distric?.uniqueId,
          ward:this.warehouse?.ward?.uniqueId,
        },
    )
  }
  selectedData(event) {
    if (event?.key === 'region') {
      this.store.dispatch(DistrictActions.getAllDistrictByRegion({regionUniqueId: event?.value}));
    }
    if (event?.key === 'distric') {
      this.store.dispatch(WardActions.getAllWardsByDistrict({districtUniqueId: event?.value}));
    }
  }
  submitForm(formValue: any) {
    const input =  {
      ...formValue,
      uniqueId:this.warehouse?.uniqueId,
    };

    this.store.dispatch(StoreItemActions.createUpdateStoreItem({
      entity: StoreItemEntity.warehouse,
      input,
      mutation: this.warehouse?.uniqueId ? UPDATE_WAREHOUSE_MUTATION : REGISTER_WAREHOUSE_MUTATION,
      isInput: true
    }))
  }

  formFields(): FieldConfig[] {
    return [
      {
        type: FieldType.input,
        label: 'Name',
        key: 'name',
        validations: [
          {
            message: 'Field is required',
            validator: Validators.required,
            name: 'required',
          },
        ],
        rowClass: 'col-span-12',
      },

        {
        type: FieldType.input,
        inputType:FieldType.number,
        label: 'Recommended Coverage Per sensor in float',
        key: 'recommendedCoveragePerSensor',
        validations: [
          {
            message: 'Field is required',
            validator: Validators.required,
            name: 'required',
          },
        ],
        rowClass: 'col-span-12',
      },
      
      {
        type: FieldType.input,
        inputType: FieldType.number,
        label: 'Size(sqm)',
        key: 'size',
        validations: [
          {
            message: 'Field should only contain integers',
            validator:  Validators.pattern(/^\d+(\.\d+)?$/),
            name: 'number',
          },
          {
            message: 'Field is required',
            validator: Validators.required,
            name: 'required',
          },
        ],
        rowClass: 'col-span-12',
      },
      {
        type: FieldType.paginatedselect,
        label: 'Region',
        key: 'region',
        query: ALL_REGIONS,
        optionName: 'name',
        optionValue: 'uniqueId',
        showOtherOption: false,
        validations: [
          {
            message: 'Field is required',
            validator: Validators.required,
            name: 'required',
          },
        ],
        rowClass: 'col-span-12',
      },
      {
        label: 'District',
        key: 'distric',
        type: FieldType.select,
        options: this.store.select(selectAllDistricts)?.pipe(map(x => {
          return x?.map(y => {
            return {...y, value: y?.uniqueId}
          })
        })),
        validations: [{
          message: 'Field is required',
          validator: Validators.required,
          name: 'required',
        }],
        rowClass: 'col-span-6'
      },
      {
        label: 'Ward',
        key: 'ward',
        type: FieldType.select,
        options: this.store.select(selectAllWards)?.pipe(map(x => {
          return x?.map(y => {
            return {...y, value: y?.uniqueId}
          })
        })),
        validations: [{
          message: 'Field is required',
          validator: Validators.required,
          name: 'required',
        }],
        rowClass: 'col-span-6'
      },

      {
        type: FieldType.button,
        label: 'Save',
        rowClass: 'col-span-12',
      },
    ];
  }
  closeModal() {
    this.dialogRef.close()
  }
}
